module.exports = __webpack_public_path__ + "media/images/admin/4pt-logo-3d811323744cef8c13c2218dc4b3464e.png";